// Reconstructed dayAgendaOptions.js - Manages agenda selection

export function setupAgendaOption() {
  const options = document.querySelectorAll('nav h4[data-tour_agenda_option]');
  if (options.length > 0) {
    options.forEach(option => {
      option.addEventListener('click', function () {
        const selectedOption = this.getAttribute('data-tour_agenda_option');

        // Update active class for h4 elements
        options.forEach(opt => {
          opt.classList.toggle('is-active', opt === this);
        });

        // Toggle display of corresponding divs
        toggleDisplay(selectedOption);
      });
    });

    function toggleDisplay(selectedOption) {
      const containers = document.querySelectorAll('[data-tour_agenda_option_container]');
      containers.forEach(container => {
        container.style.display = container.getAttribute('data-tour_agenda_option_container') === selectedOption ? 'block' : 'none';
      });
    }

    // Initialize by showing the first option and marking it as active
    if (options.length > 0) {
      options[0].classList.add('is-active');
      toggleDisplay(options[0].getAttribute('data-tour_agenda_option'));
    }
  }
}
